import { Reducer } from 'redux';
import { CardReceivablesState, CardReceivablesTypes } from './types';

const INITIAL_STATE: CardReceivablesState = {
  cardNumber: '',
  transactionsList: null,
  pixPayment: null,
  historyList: null,
  loading: false,
  generatingPayment: false,
  historyLoading: false,
  error: false,
};

const reducer: Reducer<CardReceivablesState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case CardReceivablesTypes.GET_CARD_PENDENCIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        transactionsList: null,
        pixPayment: null,
      };
    case CardReceivablesTypes.GET_CARD_PENDENCIES_SUCCESS:
      return {
        ...state,
        loading: false,
        cardNumber: action.payload.cardNumber,
        transactionsList: action.payload.transactionsList,
      };
    case CardReceivablesTypes.GET_CARD_PENDENCIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    case CardReceivablesTypes.GENERATE_CARD_PAYMENT_REQUEST:
      return {
        ...state,
        generatingPayment: true,
        error: false,
      };
    case CardReceivablesTypes.GENERATE_CARD_PAYMENT_SUCCESS:
      return {
        ...state,
        generatingPayment: false,
        pixPayment: action.payload.pixPayment,
      };
    case CardReceivablesTypes.GENERATE_CARD_PAYMENT_FAILURE:
      return {
        ...state,
        generatingPayment: false,
        error: true,
      };

    case CardReceivablesTypes.GET_CARD_HISTORY_REQUEST:
      return {
        ...state,
        historyLoading: true,
        error: false,
      };
    case CardReceivablesTypes.GET_CARD_HISTORY_SUCCESS:
      return {
        ...state,
        historyLoading: false,
        historyList: action.payload.historyList,
      };
    case CardReceivablesTypes.GET_CARD_HISTORY_FAILURE:
      return {
        ...state,
        historyLoading: false,
        error: true,
      };

    case CardReceivablesTypes.REFRESH_CARD_PAYMENT_SUCCESS:
    case CardReceivablesTypes.RELEASE_CARD_PAYMENT_SUCCESS:
      return {
        ...state,
        historyList: (state.historyList || []).map((payment) =>
          payment.paymentId === action.payload.payment.paymentId
            ? action.payload.payment
            : payment,
        ),
      };

    case CardReceivablesTypes.RESET_CARD_RECEIVABLES:
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default reducer;
